module.exports = __webpack_public_path__ + "img/tl.2b90a537.png";